<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" @remoteMethod="getHospital"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#F9FAFC" title="导出" fontSize="14px" @btnclick="CustomerQuotaExport"
					:src="require('@/assets/channel/export.png')">
				</Commonbtn>
			</div>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" width="1000px" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import headerData from './TableData/headerData'
	import utils from "../../../../../../common/utils";
	import {
		InventoryClassList,
		HospitalList
	} from '@/api/home'
	import {
		GetManufacturerList
	} from '@/api/channel'
	import {
		GetSampleList,
		ExportSampleListData,
		GetHelperSampleType
	} from '@/api/newsapi'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				dialogVisibleDel: false, //删除弹窗
				tableDatadrjg: [],
				dialogVisiblesdrjg: false,
				selectIds: [],
				downlist: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.getManufacturerList();
			this.getHelperSampleType();
			this.getData();
		},
		methods: {
			async getData() {
				this.query.Inventory = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.MFCode = this.FromArr[2].modelvalue;
				this.query.ApplyCode = this.FromArr[3].modelvalue;
				this.query.Customer = this.FromArr[4].modelvalue;
				this.query.Purpose = this.FromArr[5].modelvalue;
				this.query.ApproveTime1 = this.FromArr[6].StartTime;
				this.query.ApproveTime2 = this.FromArr[6].EndTime;
				this.query.Hospital = this.FromArr[7].modelvalue;
				this.query.SampleType = this.FromArr[8].modelvalue;
				let {
					code,
					data
				} = await GetSampleList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 生产厂商
			async getManufacturerList() {
				let {
					code,
					message,
					data
				} = await GetManufacturerList({})
				if (code == 0) {
					this.FromArr[2].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.MFName,
							key: item.MFCode,
						}
						this.FromArr[2].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			// 样品类型
			async getHelperSampleType() {
				let {
					code,
					message,
					data
				} = await GetHelperSampleType({})
				if (code == 0) {
					this.FromArr[8].options = []
					data.map((item, index) => {
						let obj = {
							value: item.Text,
							key: item.Value + '',
						}
						this.FromArr[8].options.push(obj)
					})
				} else {
					this.$message.error(message)
				}
			},
			async getHospital(val) {
				let {
					code,
					data
				} = await HospitalList({
					HPName: val.qurey
				})
				if (code == 0) {
					this.FromArr[7].options = []
					data.data.forEach((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID,
						}
						this.FromArr[7].options.push(obj)
					})
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					if (index === 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = '';
					return item;
				})
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			// 导出
			async CustomerQuotaExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				this.query.Inventory = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.MFCode = this.FromArr[2].modelvalue;
				this.query.ApplyCode = this.FromArr[3].modelvalue;
				this.query.Customer = this.FromArr[4].modelvalue;
				this.query.Purpose = this.FromArr[5].modelvalue;
				this.query.ApproveTime1 = this.FromArr[6].StartTime;
				this.query.ApproveTime2 = this.FromArr[6].EndTime;
				this.query.Hospital = this.FromArr[7].modelvalue;

				let resexprot = await ExportSampleListData(this.query)
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `样品汇总${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close()
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 220px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 0px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.custom-table {
		cursor: pointer;
		user-select: none;
		margin-bottom: 16px;
		box-sizing: border-box;

		.table-header {
			height: 40px;
			background: #00266D;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0px 16px;

			span {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.red {
			background: #E71D43;
		}

		.table-title {
			display: flex;

			.title-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.title-item:last-child {
				border-right: 0px;
			}
		}

		.table-value {
			display: flex;

			.value-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.value-item:last-child {
				border-right: 0px;
			}
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}
</style>